import { render, staticRenderFns } from "./viewTaller.vue?vue&type=template&id=4e87a36f&"
import script from "./viewTaller.vue?vue&type=script&lang=js&"
export * from "./viewTaller.vue?vue&type=script&lang=js&"
import style0 from "./viewTaller.vue?vue&type=style&index=0&id=4e87a36f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports